import React, { useCallback, useEffect, useState } from "react"
import { Link } from "react-router-dom"

import _ from "lodash"
import { getBurnoutProofDashboardResults } from "../../../requesters/CalculatorResultsRequester"
import WellbeingIndexChart from "../WellbeingIndexChart"
import IndexGauge from "../IndexGauge"
import { OVERVIEW_PAGE_CONTENT } from "../constants"
import { getAssetPath } from "../../../utils/assets"
import BurnoutProofBreakdownCard from "./BurnoutProofBreakdownCard"

function Dashboard({ baseUrl, currentUser }) {
  const [surveyResults, setSurveyResults] = useState([])
  const [recommendation, setRecommendation] = useState({})
  const [inflight, setInflight] = useState(true)

  useEffect(() => {
    document.title = "Performance Intelligence Academy | Burnout Proof Dashboard"
  }, [])

  const fetchResults = useCallback(() => {
    getBurnoutProofDashboardResults(baseUrl, currentUser)
      .then(res => {
        if (res.response.json?.calculator_results) {
          const recentResults = res.response.json?.calculator_results
          setSurveyResults(recentResults)
          setRecommendation(_.get(recentResults, "0.recommendation", {}))
        }
        setInflight(false)
        return null
      }).catch(err => {
        setInflight(false)
        // eslint-disable-next-line no-console
        console.log(err)
      })
  }, [baseUrl, currentUser])

  useEffect(() => {
    fetchResults()
  }, [fetchResults])

  if (inflight) {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }

  // Route to linking code page when User not enrolled in a program
  if (!currentUser?.active_enrolment) {
    window.location.href = "/overview"
  } else if (!surveyResults?.length && !inflight) {
    window.location.href = "/overview"
  }

  return (
    <div className="dashboard-body">
      <div className="content">
        <div className="container dashboard" id="dashboard-10dwc">
          <div className="d-flex align-items-center justify-content-between py-4">
            <div>
              <Link
                to="/overview"
                className="back-to-overview">
                <img src={getAssetPath("icn-back")} />
              </Link>
              <img src={getAssetPath(OVERVIEW_PAGE_CONTENT.burnout_proof.logoAssetName)} />
            </div>
            <div className="start-survey">
              <Link className="btn btn-main ml-4" to="/burnout-proof/intro">Start Survey</Link>
              <div className="small">{`Last completed on ${surveyResults[0]?.completed_at}`}</div>
            </div>
          </div>
          <div className="dash-row row wellness-index">
            <div className="col-lg-4">
              <div className="card">
                <div className="card-body">
                  <div className="pre-text">Your Burnout Proof Calculator Score</div>
                  <div className="gauge">
                    <IndexGauge
                      category={surveyResults[0]?.wellbeing_index_category}
                      color={surveyResults[0]?.wellbeing_index_color}
                      index={surveyResults[0]?.wellbeing_index} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
                  <div className="pre-text">Your Burnout Proof Calculator Score Trend</div>
                  <WellbeingIndexChart results={surveyResults} />
                  <p className="mt-5 mb-0 text-right">
                    <small>
                      Higher score denotes higher risk
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="dash-row row">
            {/* TODO: add the link to the BPC about page when created */}
            <div className="col-lg-4"><Link className="btn btn-lg-block bg-main" to="/about-burnout-proof">What is BPC?</Link></div>
            {currentUser.active_enrolment?.burnout_proof_latest_submitted_id && (
              <div className="col-lg-8">
                <a
                  className={`btn btn-lg-block btn-outline-main${surveyResults[0]?.download_pdf_url ? "" : " disabled"}`}
                  target="_blank"
                  rel="noreferrer"
                  href={surveyResults[0]?.download_pdf_url || undefined}
                  aria-disabled={!surveyResults[0]?.download_pdf_url}
                  tabIndex={surveyResults[0]?.download_pdf_url ? undefined : -1}
                  onClick={e => { if (!surveyResults[0]?.download_pdf_url) e.preventDefault() }}>
                  {/* TODO: add the download icon */}
                  Download Latest Report
                </a>
              </div>
            )}
          </div>
          <BurnoutProofBreakdownCard surveyResults={surveyResults} />

          <div className="dash-row card">
            <div className="card-body">
              <div className="pre-text">How to improve</div>
              <h3>Recommendation</h3>
              <div className="mb-3">
                <p>
                  {recommendation?.initial_content}
                  <b>{recommendation?.title}</b>
                  {recommendation?.main_content}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
